// API Configuration
export const API_CONFIG = {
  // GraphQL API settings
  GRAPHQL_API_URL: process.env.REACT_APP_GRAPHQL_API_URL || 'https://ai.core.claiva.com/graphql',
  API_KEY: process.env.REACT_APP_API_KEY || 'da2-w3smaw3sm5du3ga6rcc6nqrfm4',
  BRAND_CODE: process.env.REACT_APP_BRAND_CODE || 'OTB',
  
  // Default search parameters
  DEFAULT_ADULTS: 2,
  DEFAULT_CHILDREN: 0,
  DEFAULT_INFANTS: 0,
  DEFAULT_DURATION: 7,
  DEFAULT_LIMIT: 10,
  
  // Feature flags
  USE_GRAPHQL_API: true, // Set to false to use legacy XML API
  
  // Debugging
  DEBUG_MODE: process.env.NODE_ENV === 'development'
}; 